import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "M2.65 16.4a.5.5 0 0 0-.49-.13.52.52 0 0 0-.35.38L.39 23a.51.51 0 0 0 .6.6l6.36-1.42a.52.52 0 0 0 .38-.35.5.5 0 0 0-.13-.49Zm15.2-9.19-11 11a.24.24 0 0 0 0 .35l1.77 1.77a.5.5 0 0 0 .71 0L20 9.68A.48.48 0 0 0 20 9l-1.79-1.79a.25.25 0 0 0-.36 0m-1.06-1.42L15 4a.48.48 0 0 0-.7 0L3.71 14.63a.51.51 0 0 0 0 .71l1.77 1.77a.24.24 0 0 0 .35 0l11-11a.25.25 0 0 0-.04-.32m5.66-4.24a4 4 0 0 0-5.66 0l-.71.71a.51.51 0 0 0 0 .71l5 4.95a.52.52 0 0 0 .71 0l.71-.71a4 4 0 0 0-.05-5.66"
    }, null, -1)
  ]));
}
const interfaceEditToolPencil = { render };
export {
  interfaceEditToolPencil as default,
  render
};
//# sourceMappingURL=interface-edit-tool-pencil.svg.js.map
